export const PASSWORD_REQUIREMENTS = 'Password must contain at least 8 characters, 1 number, 1 uppercase letter, and 1 special character.';

export function getPasswordChecks(password: string) {
  return [
    { label: 'At least 8 characters', met: password.length >= 8 },
    { label: 'At least 1 number', met: /[0-9]/.test(password) },
    { label: 'At least 1 uppercase letter', met: /[A-Z]/.test(password) },
    { label: 'At least 1 special character (e.g. ! @ # $)', met: /[\p{P}\p{S}]/u.test(password) },
  ];
}

export function isValidSignupPassword(password: unknown): password is string {
  return typeof password === 'string'
    && getPasswordChecks(password).every((check) => check.met);
}
